module.exports = __webpack_public_path__ + "img/search.210a558e.svg";